function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 400,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}

function updateInventoryNumber(variantId, container) {
  const span = container.querySelector(".u-number");
  if (!span) return;

  const storageKey = "u-number_" + variantId;
  let storedValue = localStorage.getItem(storageKey);

  if (!storedValue) {
    const min = parseInt(span.dataset.min) || 3;
    const max = parseInt(span.dataset.max) || 9;

    storedValue = Math.floor(Math.random() * (max - min + 1)) + min;
    localStorage.setItem(storageKey, storedValue);
  }

  span.textContent = storedValue;
}

function initInventoryBlocks() {
  document.querySelectorAll(".uinventory-box").forEach((container) => {
    const variantId = container.dataset.variantId;
    if (variantId) {
      updateInventoryNumber(variantId, container);
    }
  });
}

/* 🔥 Dawn Variant Change Fix */
document.addEventListener("change", function (event) {
  const form = event.target.closest("form[action*='/cart/add']");
  if (!form) return;

  const variantInput = form.querySelector("[name='id']");
  if (!variantInput) return;

  const variantId = variantInput.value;
  const container = form.closest(".product").querySelector(".uinventory-box");

  if (variantId && container) {
    container.dataset.variantId = variantId;
    updateInventoryNumber(variantId, container);
  }
});

/* Initial Load */
document.addEventListener("DOMContentLoaded", function () {
  initInventoryBlocks();
});
